import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { PinIcon } from './PinIcon';
const component = {
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            ReactDOM.render(React.createElement(PinIcon), this.$element[0]);
            this.$element[0].style.display = 'inline-flex';
        }
        $onDestroy() {
            ReactDOM.unmountComponentAtNode(this.$element[0]);
        }
    },
};
export default angular
    .module('doxy.common.components.pinIcon', [])
    .component('pinIcon', component).name;
